import React, { useMemo } from 'react';
import { ContentfulEntry } from '@jbhi-fi/apis/src/contentful/types';
import { CONTENT_ENTRIES, getContentEntry } from './contentEntries';

export type ContentEntryProps = {
  entry: ContentfulEntry<unknown>;
  overrides?: Partial<typeof CONTENT_ENTRIES>;
};

export const ContentEntry = ({ entry, overrides }: ContentEntryProps) => {
  const { Component, props } = useMemo(() => {
    const { Component, transformer } = getContentEntry(entry, overrides) ?? {
      Component: null,
      transformer: null,
    };
    const props = transformer?.(entry);
    return { Component, props };
  }, [entry, overrides]);

  if (!Component || !props) {
    return null;
  }

  return <Component {...props} />;
};
